export const synonyms: Record<string, string[]> = {
  "tell me about yourself": ["walk me through your background", "introduce yourself"],
  "significant challenge": ["biggest challenge", "hardest problem", "a time you struggled"],
  "why this company": ["why do you want to work here", "what interests you about us"],
  "biggest weakness": ["areas for improvement", "what�s your weakness"],
};